//test
import {setCookie,getCookie,delCookie} from '../common/js/cookie.js'

export const increment = ({commit}) => {
    commit('INCREMENT')
}
export const decrement = ({commit}) => {
    commit('DECREMENT')
}

export const setGroupId = ({commit},groupid) =>{
	setCookie('groupid', groupid,'Session');
	commit('SETGROUPID',groupid)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js